import { Sparkles } from 'lucide-react'
import { TranscriptionConfig } from './types'
import { PRESETS } from './presets'

interface PresetBarProps {
  config: TranscriptionConfig
  onPresetSelect: (config: TranscriptionConfig) => void
}

export function PresetBar({ onPresetSelect }: PresetBarProps) {
  return (
    <div className="mb-4 p-3 bg-surface-900/50 border border-white/5 rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-purple-400" />
          <span className="text-sm font-medium text-gray-300">Quick Presets</span>
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2">
        {Object.entries(PRESETS).map(([key, preset]) => (
          <button
            key={key}
            type="button"
            onClick={() => onPresetSelect(preset.config as TranscriptionConfig)}
            className="px-3 py-2 text-left bg-surface-800/50 border border-white/5 rounded-lg hover:border-primary-500/50 hover:bg-surface-800/80 transition-all group"
          >
            <div className="text-sm font-medium text-gray-200 group-hover:text-primary-400">
              {preset.name}
            </div>
            <div className="text-xs text-gray-500 mt-0.5">{preset.description}</div>
          </button>
        ))}
      </div>
    </div>
  )
}
